export default "__VITE_ASSET__6d9bd3d1__"